import ClockComponent from './clock.component';

export default ClockComponent;
